export const INSIGHT_CONFIG_LOCAL_STORAGE = 'insightsConfig'
export const CALL_FILTER_LOCAL_STORAGE = 'callFilterConfig'
export const NO_CALL_TYPE = 'No Call Type'
export const OFFICE_OPEN = 'OFFICE OPEN'
export const OFFICE_CLOSED = 'OFFICE CLOSED'
export const LUNCH = 'LUNCH'
export const OFFICE_DAYS = [
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
	'Sunday',
]
export const DEFAULT_OFFICE_TIMINGS = {
	starts_at: '09:00',
	ends_at: '17:00',
	lunch_starts_at: '12:00',
	lunch_ends_at: '13:00',
}
export const EMPTY_SCHEDULE_ERROR_MESSAGE =
	'Office hours are required for the IVR.'
export const IVR_OFFICE_HOURS_ERROR_MESSAGE =
	'Lunch hours are linked to IVR. Contact support to update.'
export const NOTES_MAX_LENGTH = 5000
export const COMPLETION_NOTE_MIN_LENGTH = 2
export const WMA_WEBLINK_SUCCESS_MESSAGE = 'WMA weblink copied to clipboard.'
export const WMA_WEBLINK_ERROR_MESSAGE =
	'Failed to copy WMA weblink to clipboard.'

export const BUTTON_TEXT_CHANGE_DURATION = 1500
export const COPIED_TEXT_EXPIRY_DURATION = 60000
export const COPY_BUTTON_TEXT = {
	COPY: 'Copy',
	COPIED: 'Copied',
}
export const DOWNLOAD_BUTTON_TEXT = {
	DOWNLOAD: 'Download',
	DOWNLOADED: 'Downloaded',
}

export const DOB_VALIDATION_MESSAGES = {
	INVALID_FORMAT: 'Date format requires MM/DD/YYYY.',
	INVALID_DATE: 'Please enter a valid date of birth.',
}

export const OFFICE_HOURS_TYPE_LUNCH = 'lunch'
export const OFFICE_HOURS_TYPES = [
	'open',
	'closed',
	OFFICE_HOURS_TYPE_LUNCH,
	'other',
]

/** Insight filter panel — source labels shown in UI and stored in localStorage */
export const FILTER_SOURCE_CALLS = 'Calls'
export const FILTER_SOURCE_PAGES = 'Pages'
export const FILTER_SOURCE_WEB_MESSAGE = 'Web Message'
/** Payload value for `sourceTypes` when Web Message is selected */
export const FILTER_SOURCE_TYPE_WMA = 'wma'

/** Section keys passed to `toggleCardDropdown` / related handlers */
export const FILTER_PANEL_SECTION_SOURCE = 'source'
export const FILTER_PANEL_SECTION_CALL_TYPES = 'callTypes'
export const FILTER_PANEL_SECTION_OFFICE_HOURS = 'officeHours'

export const FILTER_PANEL_LABELS = {
	filterTitle: 'Filter',
	sectionSource: 'Source',
	sectionCallTypes: 'Call Types',
	sectionOfficeHours: 'Office Hours',
	validationSelectOne: 'At least one item must be selected',
	selectAll: 'Select All',
	selectNone: 'None',
	apply: 'Apply',
}
export const LOGIN_EXPIRY_DURATION_MS = 15 * 24 * 60 * 60 * 1000 // 15 days
export const LOGIN_TIMESTAMP_KEY = 'login_timestamp'

/** Show selection column for forwarding numbers in settings page */
export const SHOW_SELECTION_COLUMN = false

export const POP_UP_CONFIRMATION_MESSAGE = {
	message1:
		'Please confirm that all calls are now being forwarded to this number, then press Confirm.',
	message2:
		'This will become your only forwarding number. These other numbers will be permanently removed from your account.',
}
